import type { WorldBounds2 } from '@strava/mre';

import type { LatLng } from '../types';

export const getWorldBounds2FromLatLngArray: (
  points: LatLng[]
) => WorldBounds2 = (points) => {
  if (points[0] === undefined) {
    throw new Error('called getBoundingBoxFromPath with empty path');
  }

  // WorldBound2 min = The south-west point of the bounds
  let latMin = Infinity;
  let lngMin = Infinity;

  // WorldBound2 max = The north-east point of the bounds
  let latMax = -Infinity;
  let lngMax = -Infinity;

  // TODO: Handle crosses of the international date line (https://strava.atlassian.net/browse/WRE-494)

  points.forEach(([lat, lng]) => {
    if (lat < latMin) {
      latMin = lat;
    }
    if (lat > latMax) {
      latMax = lat;
    }

    if (lng < lngMin) {
      lngMin = lng;
    }
    if (lng > lngMax) {
      lngMax = lng;
    }
  });

  return {
    northEastCorner: { latitude: latMax, longitude: lngMax },
    southWestCorner: { latitude: latMin, longitude: lngMin }
  };
};
